import React from "react";
import Body from "./Body";

const Influencer = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default Influencer;
